const fotos = (pasta, total) =>
  Array.from({ length: total }, (_, i) => `/fotos/${pasta}/${String(i + 1).padStart(2, "0")}.webp`);

export const COMODIDADE_ICONS = {
  "Ar condicionado": "snowflake",
  "Mini cozinha": "chef-hat",
  "Tv": "tv",
  "Lareira": "flame",
  "Banheiro privativo": "bath",
  "Piscina privativa": "waves",
  "Wifi": "wifi",
  "Acessibilidade": "accessibility",
  "Acesso à Piscina Coletiva": "waves",
  "Piscina": "waves",
  "Jacuzzi": "droplets",
};

export const CABANAS = [
  {
    id: "cabana-ponei",
    nome: "Cabana Pônei",
    preco: 1150,
    capacidade: 6,
    descricao:
      "O quarto acomoda até 06 hóspedes com 02 camas de casal mais 01 sofá cama.",
    comodidades: [
      "Ar condicionado",
      "Mini cozinha",
      "Tv",
      "Lareira",
      "Banheiro privativo",
      "Piscina privativa",
      "Wifi",
    ],
    fotos: fotos("ponei", 10),
  },
  {
    id: "cabana-ovelha",
    nome: "Cabana Ovelha",
    preco: 1150,
    capacidade: 6,
    descricao:
      "A Cabana Ovelha é um refúgio aconchegante, ideal para até 6 pessoas. Com uma cama de casal no segundo andar, outra no térreo e um sofá-cama, oferece todo o conforto para momentos de descanso.",
    comodidades: [
      "Ar condicionado",
      "Mini cozinha",
      "Tv",
      "Lareira",
      "Banheiro privativo",
      "Piscina privativa",
      "Wifi",
    ],
    fotos: fotos("ovelha", 10),
  },
  {
    id: "cabana-cisne",
    nome: "Cabana Cisne",
    preco: 1150,
    capacidade: 4,
    descricao: "Cabana Cisne é nossa opção com acessibilidade, ideal para até 4 pessoas.",
    comodidades: [
      "Ar condicionado",
      "Mini cozinha",
      "Tv",
      "Lareira",
      "Banheiro privativo",
      "Acessibilidade",
      "Piscina privativa",
      "Wifi",
    ],
    fotos: fotos("cisne", 10),
  },
  {
    id: "cabana-cabra",
    nome: "Cabana Cabra",
    preco: 910,
    capacidade: 4,
    descricao:
      "A Cabana Cabra é um refúgio acolhedor e ideal para até 4 pessoas. Com uma cama de casal no segundo andar e sofá-cama no piso térreo, ela oferece todo o conforto para sua estadia.",
    comodidades: [
      "Ar condicionado",
      "Mini cozinha",
      "Tv",
      "Lareira",
      "Banheiro privativo",
      "Wifi",
      "Acesso à Piscina Coletiva",
    ],
    fotos: fotos("cabra", 10),
  },
  {
    id: "cabana-lhama",
    nome: "Cabana Lhama",
    preco: 910,
    capacidade: 4,
    descricao:
      "Cabana Lhama é um refúgio aconchegante, ideal para até 4 pessoas. Com uma cama no mezanino e um sofá-cama no térreo, ela oferece todo o conforto para sua estadia.",
    comodidades: [
      "Ar condicionado",
      "Mini cozinha",
      "Tv",
      "Lareira",
      "Banheiro privativo",
      "Wifi",
      "Acesso à Piscina Coletiva",
    ],
    fotos: fotos("lhama", 9),
  },
  {
    id: "casa-pavao",
    nome: "Casa Pavão",
    preco: 1300,
    capacidade: 8,
    descricao:
      "O quarto acomoda até 8 hóspedes e conta com 2 quartos: o primeiro possui 2 camas de casal, e o segundo oferece 1 cama de casal e 1 sofá-cama.",
    comodidades: [
      "Ar condicionado",
      "Mini cozinha",
      "Tv",
      "Lareira",
      "Banheiro privativo",
      "Piscina",
      "Jacuzzi",
      "Wifi",
    ],
    fotos: fotos("pavao", 10),
  },
  ...["07", "08", "09", "10", "11"].map((num) => ({
    id: `cabana-${num}`,
    nome: `Cabana ${num}`,
    preco: 750,
    capacidade: 2,
    descricao: `A Cabana ${num} é um refúgio encantador, ideal para até 2 pessoas. Com uma cama de casal voltada para o lago, oferece uma vista deslumbrante que dá a sensação de estar sobre a água. A cabana conta com banheiro privativo e uma cozinha equipada com frigobar, micro-ondas e utensílios básicos, garantindo todo o conforto durante a estadia. Compacta, moderna e aconchegante, é o lugar perfeito para relaxar e viver momentos especiais em meio à natureza. Na área externa, o deck privativo de frente para o lago convida ao descanso, com lareira externa e sala de estar, churrasqueira privativa, mesa para café da manhã e guarda-sol, o cenário ideal para apreciar o melhor da Vila Gramado.`,
    comodidades: [
      "Banheiro privativo",
      "Mini cozinha",
      "Lareira",
      "Wifi",
    ],
    comodidadesExtras: [
      "Vista para o lago",
      "Deck privativo",
      "Churrasqueira privativa",
      "Lareira externa",
      "Mesa para café da manhã",
    ],
    fotos: fotos("lago", 6),
  })),
];

export const DECORACOES = [
  {
    id: "nenhuma",
    nome: "Sem decoração",
    preco: 0,
    imagem: null,
    itens: [],
    destaque: "",
  },
  {
    id: "basica",
    nome: "Opção 1 — Básica",
    preco: 350,
    imagem: "/decor-1.jpg",
    itens: [
      "Ambiente aconchegante para momentos especiais",
      "Pétalas de rosas sobre a cama",
      "Velas aromáticas decorativas",
      "Balões em formato de coração",
      "Frutas e chocolates finos",
    ],
    destaque: "Ideal para surpresas simples e delicadas",
  },
  {
    id: "premium",
    nome: "Opção 2 — Premium",
    preco: 480,
    imagem: "/decor-2.jpg",
    itens: [
      "Cenário encantador para celebrar o amor",
      "Cama decorada com pétalas em formato de coração",
      "Balões no teto com fitas vermelhas",
      "Velas aromáticas + luminárias LED",
      "Bandeja com espumante, taças e morangos",
      "Música ambiente personalizada",
    ],
    destaque: "Perfeito para aniversários de namoro ou pedidos especiais",
  },
  {
    id: "luxo",
    nome: "Opção 3 — Luxo",
    preco: 650,
    imagem: "/decor-3.jpg",
    itens: [
      "Uma noite inesquecível e cheia de detalhes",
      "Caminho de pétalas até o quarto",
      "Cama com decoração personalizada (iniciais do casal em pétalas)",
      "Balões metalizados + cortina de coração",
      "Velas aromáticas + iluminação romântica",
      "Espumante, taças, frutas e fondue de chocolate",
      "Toalhas dobradas em formato de cisnes apaixonados",
    ],
    destaque: "Ideal para noites de núpcias ou datas marcantes",
  },
];

export const TAXA_PET = 200;

export const CONTATO = {
  endereco: "Estrada da Tapera, 1165 - Várzea Grande, Gramado - RS, 95670-000",
  whatsapp: "51 9830-8633",
  whatsappLink: "555198308633",
  email: "admvilagramado@gmail.com",
  cnpj: "52.027.993/0001-99",
};

export const FAQ = [
  {
    pergunta: "Posso levar meu pet?",
    resposta:
      "Sim! Somos pet friendly. Cobramos uma taxa de R$ 200,00 para higienização do espaço após a hospedagem com animais de estimação.",
  },
  {
    pergunta: "Algo incluso na acomodação?",
    resposta: "Sim! Café da manhã e jantar são inclusos na acomodação.",
  },
  {
    pergunta: "Onde fica localizada?",
    resposta: "A Vila Gramado fica em Várzea Grande, Gramado - Rio Grande do Sul.",
  },
  {
    pergunta: "Qual o horário de Check-in?",
    resposta: "Check-in a partir das 12:00 horas.",
  },
  {
    pergunta: "Qual o horário de Check-out?",
    resposta: "Check-out até as 16:00 horas.",
  },
];

export const formatBRL = (v) =>
  v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
